import { configure } from "identity-frontend"

configure({
  baseURL: "https://unryqf2pia.execute-api.us-west-1.amazonaws.com/prod",
})

export * from "identity-frontend"
